module.exports = __webpack_public_path__ + "img/mile1.8a2b82f1.jpg";